// Initialize Foundation for Sites

jQuery(document).foundation()
